import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as api from '../../../api'
import Spinner from '../../../Plateforme/Atoms/Spinner';
import H2 from '../../../Plateforme/Atoms/H2';
import { SDE2024MultiSelectOptionsB } from '../../../Plateforme/Utils/Listings';

const ProjectContainer = styled.div`
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
    margin: 10px 0;
`

const ColorBlock = styled.div`
    width: 50px;
    height: 30px;
    border-radius: 5px;
    display: inline-block;
`

function valuesToString(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value)).map(opt => opt.label).join(', ')
}

const FichePopBPage = () => {
    const selectRef = React.useRef(null);

    const [event, setEvent] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [companies, setCompanies] = useState([]);

    // get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
    }, [event])
    function getAllParticipations(){
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            console.log("response.data de get all participations");
            console.log(response.data);
            const _selectedCompany = response.data.find(p => p.participation.userId === new URLSearchParams(window.location.search).get("uid"));
            setSelectedUser(_selectedCompany);
            setCompanies(response.data.filter(participation => participation.participation.type[3] === "a"))
        }).catch((error) => {
            console.log(error);
        });
    }

    function addToShortlist() {

        if(selectedUser.participation.userId === "manual user"){
            let currentShortlist = companies.find((company) => company.participation._id === selectRef.current.value).shortlist;
            if (!currentShortlist) {
                currentShortlist = {valide:[],refuse:[],enattente:[]}
            }
            currentShortlist.valide.push(selectedUser.participation._id);
            api.UpsertShortlist(selectRef.current.value,currentShortlist).then((_response) => {
                getAllParticipations();
                alert("Profil ajouté à la shortlist")
                console.log(_response.data);
            }).catch((error) => {
                console.log(error);
            });
            return;
        }
        api.SubmitCadidature({
            userId: selectedUser.user._id,
            participationId: selectRef.current.value,
            message: "",
            projets: []
        }).then((response) => {
            console.log(response);
            let currentShortlist = companies.find((company) => company.participation._id === selectRef.current.value).shortlist;
            if (!currentShortlist) {
                currentShortlist = {valide:[],refuse:[],enattente:[]}
            }
            currentShortlist.valide.push(selectedUser.participation._id);
            api.UpsertShortlist(selectRef.current.value,currentShortlist).then((_response) => {
                getAllParticipations();
                alert("Profil ajouté à la shortlist")
                console.log(_response.data);
            }).catch((error) => {
                console.log(error);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    
    const archiIntList = SDE2024MultiSelectOptionsB.archiIntListB("fr");
    const rechercheProcess = SDE2024MultiSelectOptionsB.rechercheProcessB("fr");
    const rechercheProduction = SDE2024MultiSelectOptionsB.rechercheProductionB("fr");
    const rechercheFlex = SDE2024MultiSelectOptionsB.rechercheFlexB("fr");
    const rechercheModel = SDE2024MultiSelectOptionsB.rechercheModelB("fr");
    const artisanatType = SDE2024MultiSelectOptionsB.artisanatTypeB("fr");
    const artisanatScale = SDE2024MultiSelectOptionsB.artisanatScaleB("fr");
    const artisanatExport = SDE2024MultiSelectOptionsB.artisanatExportB("fr");
    const mobilierType = SDE2024MultiSelectOptionsB.mobilierTypeB("fr");
    const mobilierExport = SDE2024MultiSelectOptionsB.mobilierExportB("fr");
    const mobilierMaterial = SDE2024MultiSelectOptionsB.mobilierMaterialB("fr");
    const mobilierScale = SDE2024MultiSelectOptionsB.mobilierScaleB("fr");

    const partData = selectedUser?.participation?.data;

    return (
        <div className='candidatures_list'>
            {selectedUser ? <>
                <br/>
                <h1 className='centered'>{selectedUser.hsCompany?.properties?.name}</h1><br/>
                {selectedUser.participation.userId !== "manual user" && <>
                    <button style={{float:"right"}} onClick={()=>window.open("/evenements/editparticipation?eid="+event._id+"&uid=" + selectedUser.user._id,"_blank","noreferrer")}>Voir la participation</button><br/><br/>
                    {/* <button style={{float:"right"}} onClick={()=>window.open("editprofile?eid="+event._id+"&poptype=b&email=" + selectedUser.user.email + "&gotostep=" + 3,"_blank","noreferrer")}>Voir les projets</button><br/><br/> */}
                    <div className='flexinfos'>
                        <span className='b'>Date d'inscription : {new Date(selectedUser.user.createdAt).toLocaleDateString('fr-FR')}</span>
                        <span className='b'>Dernière connexion : {new Date(selectedUser.user.last_connection_date).toLocaleDateString('fr-FR')}</span>
                    </div>
                </>}
                <div className='flexinfos'>
                    <span className='b'>Candidature(s) : {selectedUser.candidatures.filter(c => companies.find(part => part.participation._id === c.participationId)).length}</span>
                    <span className='b'>Shortlist(s) : {companies.filter(c => c.shortlist?.valide.includes(selectedUser.participation._id)).length}</span>
                </div>
                <br/>
                {selectedUser.candidatures.filter(c => companies.find(part => part.participation._id === c.participationId)).sort((a,b) => a.priorite - b.priorite).map((c,i) =>
                    {
                        let shortlist = companies.find(part => part.participation._id === c.participationId)?.shortlist;

                        let color = "lightgrey"
                        if(shortlist?.valide.includes(selectedUser.participation._id)){
                            color = "green"
                        }
                        if(shortlist?.refuse.includes(selectedUser.participation._id)){
                            color = "red"
                        }
                        if(shortlist?.enattente.includes(selectedUser.participation._id)){
                            color = "purple"
                        }

                        return (
                            <div className='companies_cont' key={i}>
                                <span className='b linkbutton' onClick={() => window.open("editshortlists?eid="+event._id+"&cid="+c.participationId,"_blank","noreferrer")}>Candidature à {companies.find(part => part.participation._id === c.participationId).hsCompany?.properties?.name}</span><br/>
                                <span className='thin'>Priorité : {c.priorite}</span><br/>
                                <span className='thin'>Shortlisté : <ColorBlock style={{backgroundColor:color}}/></span>
                            </div>
                        )
                    }
                )}
                <div className='company'>
                    <span className='b'>Associer ce contact à une Shortlist (pop A)</span><br/>
                    <select ref={selectRef}>
                        {companies.filter(part => !selectedUser.candidatures.find(cand => cand.participationId === part.participation._id) && !part.shortlist?.valide.includes(selectedUser.participation._id) && !part.shortlist?.refuse.includes(selectedUser.participation._id) && !part.shortlist?.enattente.includes(selectedUser.participation._id) && part.participation.data?.entreprise_validee).sort((a,b) => a.hsCompany?.properties?.name.localeCompare(b.hsCompany?.properties?.name)).map((c,i) =>
                            <option key={i} value={c.participation._id}>{c.hsCompany?.properties?.name}</option>
                        )}
                    </select>
                    <button onClick={addToShortlist}>Ajouter à la shortlist</button>
                </div>
                {selectedUser.participation.userId !== "manual user" && <>
                    <br/>
                    <br/>
                    <H2>Profil & société</H2>
                    <br/>
                    <br/>
                    <b>Email :</b> <span className='thin'>{selectedUser.hsProfile.email}</span><br/><br/>
                    <b>Prénom :</b> <span className='thin'>{selectedUser.hsProfile.firstname}</span><br/><br/>
                    <b>Nom :</b> <span className='thin'>{selectedUser.hsProfile.lastname}</span><br/><br/>
                    <b>Téléphone portable :</b> <span className='thin'>{selectedUser.hsProfile.mobilephone}</span><br/><br/>
                    <b>Téléphone fixe :</b> <span className='thin'>{selectedUser.hsProfile.phone}</span><br/><br/>
                    <b>Intitulé du poste :</b> <span className='thin'>{selectedUser.hsProfile.jobtitle}</span><br/><br/>
                    <b>Profil :</b> <span className='thin'>{selectedUser.hsProfile.cat_gories_via}</span><br/><br/>
                    {selectedUser.participation.type[2] === "e" && <>
                        <br/>
                        <H2>Participation</H2>
                        <br/>
                        <br/>
                        <b>Sur quels types de projets travaillez-vous principalement :</b> <span className='thin'>{valuesToString(partData.type_projets, archiIntList)}</span><br/><br/>
                        <b>Précisions :</b> <span className='thin'>{partData.type_projets_precisions}</span><br/><br/>
                        <br/>
                        <b>Quels sont vos spécificités / savoir-faire | Artisanat d'art | Type de savoir-faire :</b> <span className='thin'>{valuesToString(partData.artisanatType, artisanatType)}</span><br/><br/>
                        <b>Quels sont vos spécificités / savoir-faire | Artisanat d'art | Échelle de production :</b> <span className='thin'>{valuesToString(partData.artisanatScale, artisanatScale)}</span><br/><br/>
                        <b>Quels sont vos spécificités / savoir-faire | Artisanat d'art | Projets à l'export :</b> <span className='thin'>{valuesToString(partData.artisanatExport, artisanatExport)}</span><br/><br/>
                        <b>Précisions :</b> <span className='thin'>{partData.artisanat_precisions}</span><br/><br/>
                        <br/>
                        <b>Quels sont vos spécificités / savoir-faire | Mobilier | Type de mobilier :</b> <span className='thin'>{valuesToString(partData.mobilierType, mobilierType)}</span><br/><br/>
                        <b>Quels sont vos spécificités / savoir-faire | Mobilier | Type de matériaux :</b> <span className='thin'>{valuesToString(partData.mobilierMaterial, mobilierMaterial)}</span><br/><br/>
                        <b>Quels sont vos spécificités / savoir-faire | Mobilier | Échelle de production :</b> <span className='thin'>{valuesToString(partData.mobilierScale, mobilierScale)}</span><br/><br/>
                        <b>Quels sont vos spécificités / savoir-faire | Mobilier | Projets à l'export :</b> <span className='thin'>{valuesToString(partData.mobilierExport, mobilierExport)}</span><br/><br/>
                        <b>Précisions :</b> <span className='thin'>{partData.mobilier_precisions}</span><br/><br/>
                        <br/>
                        <b>En quoi votre candidature correspond aux critères recherchés | Nouveaux modèles de l'économie circulaire :</b> <span className='thin'>{valuesToString(partData.rechercheModel, rechercheModel)}</span><br/><br/>
                        <b>En quoi votre candidature correspond aux critères recherchés | Process innovants :</b> <span className='thin'>{valuesToString(partData.rechercheProcess, rechercheProcess)}</span><br/><br/>
                        <b>En quoi votre candidature correspond aux critères recherchés | Production locale :</b> <span className='thin'>{valuesToString(partData.rechercheProduction, rechercheProduction)}</span><br/><br/>
                        <b>En quoi votre candidature correspond aux critères recherchés | Flexibilité d'usage :</b> <span className='thin'>{valuesToString(partData.rechercheFlex, rechercheFlex)}</span><br/><br/>
                        <b>Précisions :</b> <span className='thin'>{partData.criteres_precisions}</span><br/><br/>
                        <br/>
                        <H2>Projets</H2>
                        {partData.projets && partData.projets.map((projet,i) =>
                            <ProjectContainer key={projet._id} style={ projet.validated ? {borderColor:"rgb(144, 221, 144)"} : {}}>
                            <h3 className='blacklower'>Projet {i + 1}</h3><br/>
                                <label>Nom du projet : {projet.title}</label>
                                <label>Type de projet : {projet.type}</label>
                                <label>Pays du projet : {projet.country}</label>
                                <label>Ville du projet : {projet.city}</label>
                                <label>Description des savoir-faire dans le cadre du projet : {projet.description}</label>
                                {projet.files && projet.files.length > 0 &&
                                    <>{projet.files.map((file,i)=>
                                        <div key={i}>
                                            <span className='thin'>{file.originalname} :</span><br/>
                                            {file.uploaded_path && (file.mimetype === "image/jpeg" || file.mimetype === "image/png" ? <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}/> : <a target="_blank" href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}>Voir le document</a>)}
                                        </div>
                                    )}</>
                                }
                                <br/>
                            </ProjectContainer>
                        )}
                    </>}
                    {selectedUser.participation.type[2] === "o" && <>
                    <H2>Projets</H2>
                        {partData.projets && partData.projets.map((projet,i) =>
                            <ProjectContainer key={projet._id} style={ projet.validated ? {borderColor:"rgb(144, 221, 144)"} : {}}>
                            <h3 className='blacklower'>Projet {i + 1}</h3><br/>
                                <label>Nom du projet : {projet.title}</label>
                                <label>Description : {projet.description}</label>
                                <label>Confidentialité : {projet.confidentialite}</label>
                                {projet.files && projet.files.length > 0 &&
                                    <>{projet.files.map((file,i)=>
                                        <div key={i}>
                                            <span className='thin'>{file.originalname} :</span><br/>
                                            {file.uploaded_path && (file.mimetype === "image/jpeg" || file.mimetype === "image/png" ? <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}/> : <a target="_blank" href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}>Voir le document</a>)}
                                        </div>
                                    )}</>
                                }
                                <br/>
                            </ProjectContainer>
                        )}
                    </>}
                </>}
            </> : <Spinner/>}
        </div>
    );
};

export default FichePopBPage;